<template>
  <section
    class="rounded-4 bg-white py-2 shadow-all-0030-black-50"
    data-test="create-chat-contact-context-menu"
    @click="$emit('hideMenu')"
  >
    <button
      v-if="canAddAsModerator"
      data-test=""
      class="button flex h-8 w-full items-center whitespace-nowrap px-2 py-1 text-left text-1316 hover:bg-primary-tints-100 hover:text-primary-shades-500"
      @click="onModeratorButtonClick"
    >
      <wui-icon
        class="icon mr-2 text-black-400"
        name="shield"
      />
      <span>{{ moderatorLabel }}</span>
    </button>
    <button
      class="button flex h-8 w-full items-center whitespace-nowrap px-2 py-1 text-left text-1316 hover:bg-primary-tints-100 hover:text-primary-shades-500"
      @click="onUserButtonClick"
    >
      <wui-icon
        class="icon mr-2 text-black-400"
        name="person"
      />
      <span>{{ userLabel }}</span>
    </button>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'

const props = withDefaults(defineProps<{
  canAddAsModerator?: boolean,
  isRemoveFromModerators?: boolean,
  isRemoveFromUsers?: boolean
}>(), {
  canAddAsModerator: false,
  isRemoveFromModerators: false,
  isRemoveFromUsers: false,
})

const emit = defineEmits<{
  (event: 'addAsModerator'): void
  (event: 'addAsUser'): void
  (event: 'removeFromModerators'): void
  (event: 'removeFromUsers'): void
  (event: 'hideMenu'): void
}>()

const { t } = useLocalization()

const moderatorLabel = computed(() => {
  return props.isRemoveFromModerators ? t('mainAside.removeFromModerators') : t('mainAside.addAsModerator')
})

const userLabel = computed(() => {
  return props.isRemoveFromUsers ? t('mainAside.removeFromUsers') : t('mainAside.addAsUser')
})

const onModeratorButtonClick = () => {
  if (props.isRemoveFromModerators) {
    emit('removeFromModerators')
    return
  }
  emit('addAsModerator')
}

const onUserButtonClick = () => {
  if (props.isRemoveFromUsers) {
    emit('removeFromUsers')
    return
  }
  emit('addAsUser')
}
</script>

<style scoped>
@reference "../../app/assets/tailwind.css";

.button:hover .icon {
  @apply text-primary-shades-500
}
</style>
